/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FileModel = {
    readonly id?: number;
    is_deleted?: boolean | null;
    readonly deleted_at?: string | null;
    readonly uploaded_date?: string;
    filename: string;
    file_type: FileModel.file_type;
    file_path: string;
    guid: string;
    external_id?: string | null;
    json_file_path?: string | null;
    uploaded_by?: number | null;
};
export namespace FileModel {
    export enum file_type {
        CSV = 'csv',
        DOC = 'doc',
        DOCX = 'docx',
        DOCM = 'docm',
        GIF = 'gif',
        JPEG = 'jpeg',
        JPG = 'jpg',
        KEY = 'key',
        NUMBERS = 'numbers',
        PAGES = 'pages',
        PDF = 'pdf',
        PNG = 'png',
        PPT = 'ppt',
        PPTX = 'pptx',
        PPSM = 'ppsm',
        PPTM = 'pptm',
        RTF = 'rtf',
        TXT = 'txt',
        XLS = 'xls',
        XLSX = 'xlsx',
        XLSM = 'xlsm',
        XLSB = 'xlsb',
        ZIP = 'zip',
    }
}

